import { CeiSnackBarService } from '@cei-ufg/ngx-arquitetura-cei-frontend';
import { notifyAdminFormError } from './admin-form.utils';

export function notifyAdminListError(
  snackBar: CeiSnackBarService,
  fallbackMessage: string,
  error?: unknown,
): void {
  notifyAdminFormError(snackBar, fallbackMessage, error);
}
